import AutomatedInvoicing from './AutomatedInvoicing';

export default AutomatedInvoicing;
